module.exports = __webpack_public_path__ + "img/DW365-071.0ac9aea7.jpg";